import { Injectable } from '@angular/core';
import { ApiService, HttpMethod } from '../common/api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators';

import { Album } from './album.model';
import { ApiUrlService } from '../common/api-url.service';

@Injectable({
    providedIn: 'root'
})
export class AlbumApiService
{
    protected apiService: ApiService;

    constructor(protected http: HttpClient,
                protected apiUrlService: ApiUrlService)
    {
        this.apiService = new ApiService(http);
    }

    getAlbum(id: number, breadcrumbs: boolean): Observable<Album>
    {
        return this.apiService.apiRequest<any>(this.apiUrlService.getAlbumsUrl(id, breadcrumbs), HttpMethod.Get)
            .pipe(
                map(json => new Album(json))
            );
    }
}
